import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
        }`}
      >
        <div className="max-w-none px-8 mx-auto flex items-center justify-between h-16">
          <a href="#home" onClick={e => { e.preventDefault(); handleNav('#home'); }}>
            <img
              src="https://cdn1.npcdn.net/images/np_25709_1707186562.png"
              alt="THIRD STUDIO"
              className="h-10 object-contain"
            />
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map(link => (
              <a
                key={link.label}
                href={link.href}
                onClick={e => { e.preventDefault(); handleNav(link.href); }}
                className={`text-sm tracking-wide font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-gray-700 hover:text-[#b08d6a]' : 'text-white hover:text-[#f5e6d3]'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden w-8 h-8 flex items-center justify-center"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl ${scrolled ? 'text-gray-800' : 'text-white'}`} />
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="fixed inset-0 z-40 bg-white flex flex-col pt-20 px-8">
          {NAV_LINKS.map(link => (
            <a
              key={link.label}
              href={link.href}
              onClick={e => { e.preventDefault(); handleNav(link.href); }}
              className="py-4 border-b border-gray-100 text-gray-700 text-base font-medium cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </>
  );
}
